import { rawApiClient } from './client'

export interface GenerateDocumentParams {
  content: string
  format: 'markdown' | 'docx' | 'pdf'
  documentType?: 'outline' | 'chapter' | 'book'
  title?: string
  author?: string
  chapterNumber?: number
}

/** 通用文档生成（公开，供智能诊疗等工具使用，不经 writing 鉴权路径） */
export async function generateDocumentBlob(
  params: GenerateDocumentParams
): Promise<Blob> {
  const response = await rawApiClient.post('/v1/documents/generate', {
    content: params.content,
    format: params.format,
    documentType: params.documentType ?? 'chapter',
    title: params.title,
    author: params.author,
    chapterNumber: params.chapterNumber,
  }, {
    responseType: 'blob',
    timeout: 300000,
  })
  return response.data as Blob
}
